import React, {useState} from 'react';
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FaTimes} from "react-icons/fa";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import {AgGridReact} from "ag-grid-react";
import phoneRender from "./phone-render";
import TruncateCellRenderer from "../../../components/cell-renderer/truncate-cell-renderer";

const ContactsModal = ({open, set, modalData}) => {
    const [columnDefs] = useState([
        {field: "name", headerName: "Nome"},
        {field: "equip", headerName: "Equipe"},
        {field: "phone", headerName: "Número", cellClass: "select-text",  cellRenderer: phoneRender},
        {field: "note", headerName: "Observação", flex: 1, minWidth: 200, cellRenderer: TruncateCellRenderer},
    ]);

    return (
        <Dialog open={open} onClose={set} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 w-full lg:w-10/12 overflow-y-auto m-auto">
                <div className="flex lg:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel transition
                                 className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-9/12 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">
                        <div className="bg-white py-4 border-b border-gray-300">
                            <div className="text-left">
                                <DialogTitle as="h3" className="font-semibold leading-6 border-b border-gray-300 px-3 flex justify-between">
                                    {modalData.title} - Contatos {modalData.principal ? "- " + modalData.principal : ""}
                                    <span onClick={() => set(false)} className="cursor-pointer">
                                        <FaTimes/>
                                    </span>
                                </DialogTitle>
                                <div className="mt-4 px-3">
                                    <div className={"ag-theme-quartz grid mt-2"} style={{height: "calc(100vh - 233px)"}}>
                                        <AgGridReact
                                            rowHeight={32}
                                            rowData={modalData.data ?? []}
                                            columnDefs={columnDefs}
                                            animateRows={false}
                                            suppressRowClickSelection={true}
                                            suppressCellFocus={true}
                                            gridOptions={{localeText: LocalizationAgGrid}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default ContactsModal;